export default {
  'storeValueCard.title': 'บัตรเติมเงิน',
  'storeValueCard.current_balance': 'ยอดคงเหลือปัจจุบัน',
  'storeValueCard.currency': 'บาท',
  'storeValueCard.online_top_up': 'เติมเงินออนไลน์',
  'storeValueCard.deduct': 'ตัดยอด',
  'storeValueCard.transaction_history': 'ประวัติการทำรายการ',
  'storeValueCard.update_time': 'เวลาอัปเดต',
  'storeValueCard.total_amount': 'จำนวนเงิน',
  'storeValueCard.store': 'สาขา',
  'storeValueCard.empty': 'ยังไม่มีประวัติการทำรายการ',
  'storeValueCard.redeem.title': 'ตัดยอด',
  'storeValueCard.redeem.enter_amount': 'กรุณากรอกจำนวนเงินที่ต้องการตัดยอด',
  'storeValueCard.redeem.enter_store_code': 'กรุณาใส่รหัสการใช้คูปอง',
  'storeValueCard.redeem.next_step': 'ถัดไป',
  'storeValueCard.redeem.success': 'ตัดยอดสำเร็จ',
  'storeValueCard.redeem.fail': 'ตัดยอดไม่สำเร็จ',
  'storeValueCard.description.title': 'คำแนะนำการใช้งาน',
  'storeValueCard.store.title': 'เติมเงินออนไลน์',
  'storeValueCard.store.coupon_alt': 'คูปองเติมเงิน',
  'storeValueCard.store.amount_prefix': 'เงินเติม {name}',
  'storeValueCard.store.description':
    'ทำการเติมเงินผ่านการชำระด้วยบัตรออนไลน์ ยอดเงินเติมสามารถใช้ที่สาขาทั้งหมดได้',
  'storeValueCard.store.top_up': 'เติมเงิน',
  'storeValueCard.store.empty': 'แบรนด์ยังไม่ได้กำหนดยอดเติมเงิน',
} as Record<string, string>;
